export function getLastUrlSegment () {
  return window.location.href.split('?')[0].split("/").pop();
}

export function getCurrentRoute(){
  const currentUrl = window.location.href;
  if(currentUrl.includes("digiboard/onboard")){
    return "DASHBOARD_ONBOARD";
  }
  if(currentUrl.includes("digiboard/findGroups")){
    return "DASHBOARD_FIND_GROUPS";
  }
  else if(currentUrl.includes("game/group/find")){
    return "GAME_FIND_GROUPS";
  }
  else if(currentUrl.includes("game/roles")){
    return "GAME_ASSIGN_ROLES";
  }else if (currentUrl.includes("game/overview")){
    return "GAME_OVERVIEW";
  }else if (currentUrl.includes("game/questions")){
    return "QUESTION_OVERVIEW";
  }else if (currentUrl.includes("digiboard/scoreBoard/")){
    return "SCORE_BOARD";
  }else if (currentUrl.includes("game/avatar")){
    return "AVATAR_DESIGNER";
  }
  return "";
}

export function getBaseLanguage(language = "") {
  return language.toLowerCase().split(/[-_]/)[0];
}

export function isEnglishLanguage(i18n) {
  return getBaseLanguage(i18n.resolvedLanguage || i18n.language) === "en";
}

export function getUserColor(str){
  //TODO: adjust base colour values below based on theme
  var baseRed = 128;
  var baseGreen = 128;
  var baseBlue = 128;

  //lazy seeded random hack to get values from 0 - 256
  //for seed just take bitwise XOR of first two chars
  var seed = str.charCodeAt(0) ^ str.charCodeAt(1);
  var rand_1 = Math.abs((Math.sin(seed++) * 10000)) % 256;
  var rand_2 = Math.abs((Math.sin(seed++) * 10000)) % 256;
  var rand_3 = Math.abs((Math.sin(seed++) * 10000)) % 256;

  //build colour
  var red = Math.round((rand_1 + baseRed) / 2);
  var green = Math.round((rand_2 + baseGreen) / 2);
  var blue = Math.round((rand_3 + baseBlue) / 2);

  return 'rgb(' + red + ',' + green + ',' + blue + ')';
}
